import React from 'react';
import { object, func, bool, array } from 'prop-types';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import { AUTH } from '../../../constants';
import style from './style';

const AppMenu = ({appMenu,onSelectMenu,profileMenu,profile,t})=>{
	return (
		<style.AppMenuWrapper>
			{
				appMenu.map(menu=>{
					return (<style.AppMenuItem key={menu.name} onClick={(e)=>{
						onSelectMenu(menu.action,e);
					}}>
						<style.AppMenuIconWrapper>
							<menu.Icon/>
						</style.AppMenuIconWrapper>
						{menu.name}
					</style.AppMenuItem>

					);
				})
			}
			<style.UserWrapper>
				<style.Avatar src={(profile && profile.imageUrl) || 'https://via.placeholder.com/100x100'} />
				<style.AppMenu 
					value={profile.userName}
					right='5px' 
					menuItems={profileMenu}
					renderMenu={(menu,_,showMenu)=>{
						return (
							<style.DropdownMenuItem key={menu.name} onClick={(e)=>{
								onSelectMenu(menu.action,e);
								showMenu(false);
							}}>{menu.name}</style.DropdownMenuItem>
						);
					}}
				/>
			</style.UserWrapper>
		</style.AppMenuWrapper>
	);
};

AppMenu.propTypes = {
	appMenu : array.isRequired,
	onSelectMenu : func.isRequired,
	profileMenu : array.isRequired,
	profile : object,
	t : func.isRequired
};

const Presenter = ({auth,onLogin,profile,appMenu,profileMenu,onSelectMenu,onClickHome,showMenu,onClickMenu,t}) =>{

	return (
		<style.Wrapper>
			<style.Leftside>
				<style.Brand onClick={onClickHome}>
					<style.Mushi1Logo/>
					MUSHIQUI
				</style.Brand>
			</style.Leftside>
			<style.Rightside>
				{
					auth.authStatus !== AUTH.LOGGED_IN ? (
						<style.UserWrapper>
							<style.LoginText onClick={onClickMenu(true)}><style.LoginIcon/>{t('header.Login')}</style.LoginText>
							<style.Signup 
								show={showMenu}
								onClose={onClickMenu(!showMenu)}
								onLogin={onLogin}
							/>
						</style.UserWrapper>
					) : (
						<AppMenu
							appMenu={appMenu}
							onSelectMenu={onSelectMenu}
							profileMenu={profileMenu}
							profile={profile}
							t={t}
						/>
					)
				}
			</style.Rightside>
		</style.Wrapper>
	);
};

Presenter.propTypes = {
	auth: object.isRequired,
	profile: object.isRequired,
	onLogin: func.isRequired,
	appMenu : array,
	profileMenu : array,
	onSelectMenu : func.isRequired,
	onClickHome : func.isRequired,
	onClickMenu : func.isRequired,
	showMenu : bool.isRequired,
	t : func.isRequired
};

export default withNamespaces()(Presenter);
